import React, { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import {
  Container,
  Header,
  Message,
  Content,
  Infos,
  BodyName,
  Button,
  LogoNotification,
} from "./styled";
import { ReactComponent as Close } from "images/icons/close.svg";
import { ReactComponent as Chat } from "images/icons/chat.svg";

const Toast = ({notifications, onClose, translate}) => {
  
  return (<Container>
    <Header>
      <LogoNotification>
        <Chat />
      </LogoNotification>
      <Content>
        <BodyName>
          <a href={notifications?.url} target="_blank" rel="noreferrer">
            {notifications?.title}
          </a>
        </BodyName>
        <Infos>{translate?.digitalkNotify}</Infos>
      </Content>
      <Button onClick={onClose}>
        <Close />
      </Button>
    </Header>
    <Message>
      <a href={notifications?.url} target="_blank" rel="noreferrer">
        {notifications?.body}
      </a>
    </Message>
  </Container>
  )
};

export default Toast;
